const HEX_COLOUR_PATTERN = /^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;

export const getSafeHexColour = (value: string | null | undefined, fallback: string): string => {
    const trimmedValue = value?.trim();
    return trimmedValue && HEX_COLOUR_PATTERN.test(trimmedValue) ? trimmedValue : fallback;
};